import { Observable, catchError, throwError } from "rxjs";
import { AbstractService } from "../core/AbstractService";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";
import { AppService } from "../core/app.service";
import { ActivtieResponse } from "../data/http/responses/activite.response";
import { ActiviteRequest } from "../data/http/requests/activite.request";

@Injectable({ // Ajoutez le décorateur Injectable
    providedIn: 'root' // Rend le service disponible dans toute l'application
})
export class ActiviteForReportService extends AbstractService<ActiviteRequest, ActivtieResponse> {
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}activite-report`, http, null, appService);
    }

    getFullTree(appId?: string): Observable<any> {
        let resolvedAppId = appId;
        if ((!resolvedAppId || resolvedAppId === 'null' || resolvedAppId === 'undefined' || resolvedAppId === 'default') && this.appService) {
            const fromToken = this.appService.getAppId();
            if (fromToken && fromToken.trim() !== '') resolvedAppId = fromToken;
        }
        if (!resolvedAppId || resolvedAppId === 'null' || resolvedAppId === 'default' || resolvedAppId === 'undefined') {
            return throwError(() => new Error('app_id manquant — impossible d’appeler l’API.'));
        }
        return this.http.get<any>(
            `${this.baseUrl}/${resolvedAppId}/full-tree`,
            { headers: this.getHeaders() }
        ).pipe(catchError(this.handleError));
    }
}
